module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker57-api.relevant-digital.com/"}};